/* eslint @typescript-eslint/no-unused-vars: 0 */ // TODO: remove this when we upgrade TS

import LabeledInput from 'components/general/inputs/LabeledInput';
import LabeledSelect from 'components/general/inputs/LabeledSelect';
import { ISelectOption } from 'components/general/types';
import { IUser } from 'components/general/types/general';
import { FormikValues } from 'formik';
import { useFormikForm } from 'hooks';
import { COUNTRIES } from 'utils/forms';

/**
 * Hook to handle common fields of the user form for both standard users and SSO users
 * @param formik the formik object returned by `useFormikForm`
 * @returns JSX for the user form: firstName, lastName, organization, userCountryCode, organizationCountryCode
 */
export const useUserForm = <T extends FormikValues>(
  formik: ReturnType<typeof useFormikForm<IUser, T>>['formik']
) => {
  const { getFieldProps, setFieldValue } = formik;

  // Change the default organization country to match the user's country
  const handleCountryChange = (value: ISelectOption | '') => {
    if (!getFieldProps('organizationCountryCode').value) {
      setFieldValue('organizationCountryCode', value);
    }
  };

  return (
    <>
      <div className="split-inputs">
        <div id="left">
          <LabeledInput
            {...getFieldProps('firstName')}
            label="First Name"
            type="text"
            placeholder="First"
            autoComplete="on"
            autoFocus
          />
        </div>
        <div id="right">
          <LabeledInput
            {...getFieldProps('lastName')}
            label="Last Name"
            type="text"
            placeholder="Last"
            autoComplete="on"
          />
        </div>
      </div>
      <LabeledInput
        {...getFieldProps('organization')}
        label="Organization"
        type="text"
        placeholder="Organization"
        autoComplete="organization"
      />
      <LabeledSelect
        {...getFieldProps('userCountryCode')}
        formikOnChange={handleCountryChange}
        label="Country of Citizenship"
        options={COUNTRIES}
      />
      <LabeledSelect
        {...getFieldProps('organizationCountryCode')}
        label="Country of Organization"
        options={COUNTRIES}
      />
    </>
  );
};
